import { FieldType, ICartItem, IFormField } from '@topshots/core-models';
import { useFormikContext } from 'formik';

export const FormFieldRenderer = ({
  field,
  value,
  onChange,
  formikPath,
}: {
  field: IFormField;
  formikPath: string;
  value: string | boolean | number;
  onChange: (newValue: string | boolean | number) => void;
}) => {
  const { getFieldProps } = useFormikContext<ICartItem>();
  switch (field.type) {
    case FieldType.Text:
      return (
        <input
          id={field.id}
          // value={value as string}
          // onChange={(e) => onChange(e.target.value)}
          placeholder={field.placeholder}
          {...getFieldProps(formikPath)}
        />
      );
    case FieldType.Number:
      return (
        <input
          id={field.id}
          type="number"
          // value={value as number}
          // onChange={(e) => onChange(Number(e.target.value))}
          placeholder={field.placeholder}
          {...getFieldProps(formikPath)}
        />
      );
    case FieldType.TextArea:
      return (
        <textarea
          id={field.id}
          // value={value as string}
          // onChange={(e) => onChange(e.target.value)}
          placeholder={field.placeholder}
          {...getFieldProps(formikPath)}
        />
      );
    case FieldType.Select:
      return (
        <select
          id={field.id}
          // value={value as string}
          // onChange={(e) => onChange(e.target.value)}
          {...getFieldProps(formikPath)}
        >
          <option value="">Select an option</option>
          {field.options?.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      );
    case FieldType.Checkbox:
      return (
        <>
          <input
            id={field.id}
            type="checkbox"
            checked={value as boolean}
            // onChange={(e) => onChange(e.target.checked)}
            {...getFieldProps(formikPath)}
          />
          <label htmlFor={field.id}>
            {field.label}
            {field.required && <span className="text-danger">*</span>}
          </label>
        </>
      );
    default:
      return null;
  }
};
